<template>
    <a-form-item label="输入验证码"
        class="form-item"
        v-bind="formItemLayout"
        :hasFeedback="hasFeedback"
        >
        <Input class="verifyCode" v-decorator="['code',
        {
            rules: [{ required: true, message: '请输入验证码' },{ validator: this.validateCode }],
        }
        ]"
        placeholder="请输入验证码"
        />
        <img :src="picCodeSet.src" alt="" class="pwdImg" @click="getCodePic" >
    </a-form-item>    
</template>

<script>
import { Input, Button } from 'ant-design-vue'
import { Base64 } from 'js-base64'
import api from '@utils/api'
import CONSTANT from '@utils/constant'

  export default {
    components: {Input, Button},
    props: {
        identity: {
            type: String,
            default: ''
        },
        appCode: {
            type: String,
            default: ''
        },
        appServiceCode: {
            type: String,
            default: ''
        },
    },
    data () {
        return {
            picCodeSet: {
                src: '',
            },
            formItemLayout: {
                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 8 },
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 16 },
                },
            },
            hasFeedback: true
        }
    },
    created() {
        this.getCodePic()
    },
    methods: {
        validateCode(rule, value, cb) {
            if (value) {
                this.hasFeedback = false
                cb()
            } else {
                this.hasFeedback = true
            }
            cb()
        },
        async getCodePic() {
            const uuidV4 = require('uuid/v4');
            const _identity = Base64.encode(`${uuidV4()}`);
            const _appCode = Base64.encode(`${CONSTANT.APPCODE}`);
            const _appServiceCode = Base64.encode(`${CONSTANT.APPSERVICECODE_LOGIN}`);
            this.picCodeSet.src = `${api.verifycodeHost}/ucode-web/ucode/getNumber.do?identity=${_identity}&appCode=${_appCode}&appServiceCode=${_appServiceCode}`
            this.$emit('update:identity', _identity)
            this.$emit('update:appCode', _appCode)
            this.$emit('update:appServiceCode', _appServiceCode)
        },
    }
  }
</script>
<style lang="scss" scoped>

.pwdImg {
    width: 94px;
    height: 38px;
    cursor: pointer;
    line-height: 38px;
    padding-left: 10px;
}
</style>